import React, {useState, useEffect, useContext, Suspense, lazy} from "react";
import "./Project.scss";
import Button from "../../components/button/Button";
import {openSource, socialMediaLinks} from "../../portfolio";
import StyleContext from "../../contexts/StyleContext";
import Loading from "../../containers/loading/Loading";

export default function Projects() {
  const GithubRepoCard = lazy(() =>
    import("../../components/githubRepoCard/GithubRepoCard")
  );
  const {isDark} = useContext(StyleContext);
  const renderLoader = () => <Loading />;
  const [reposData, setReposData] = useState([]);

  useEffect(() => {
    async function fetchRepoData() {
      const staticRepos = openSource.repos || [];
      const results = [];

      for (const repo of staticRepos) {
        const url = `https://api.github.com/repos/${repo.org}/${repo.id}`;
        try {
          const res = await fetch(url);
          if (!res.ok) throw new Error(`Failed to fetch ${repo.id}`);
          const data = await res.json();

          // Transform into GithubRepoCard-compatible schema
          results.push({
            node: {
              id: data.id,
              name: data.name,
              description: data.description || "No description provided.",
              url: data.html_url,
              stargazers: {totalCount: data.stargazers_count},
              forkCount: data.forks_count,
              diskUsage: data.size, // KB
              primaryLanguage: data.language
                ? {name: data.language, color: getLanguageColor(data.language)}
                : null
            }
          });
        } catch (err) {
          console.error(`Error fetching repo ${repo.id}:`, err);
        }
      }
      setReposData(results);
    }

    fetchRepoData();
  }, []);

  function getLanguageColor(language) {
    const colors = {
      Python: "#3572A5",
      JavaScript: "#f1e05a",
      TypeScript: "#2b7489",
      "C++": "#f34b7d",
      C: "#555555",
      Jupyter: "#DA5B0B",
      Shell: "#89e051",
      HTML: "#e34c26",
      Java: "#b07219"
    };
    return colors[language] || "#ccc";
  }

  if (!openSource.display) return null;

  return (
    <Suspense fallback={renderLoader()}>
      <div className="main" id="opensource">
        <h1 className="project-title">Open-Source Projects</h1>
        <div className="repo-cards-div-main">
          {reposData.map(repo => (
            <GithubRepoCard repo={repo} key={repo.node.id} isDark={isDark} />
          ))}
        </div>
        <Button
          text={"More Projects"}
          className="project-button"
          href={socialMediaLinks.github}
          newTab={true}
        />
      </div>
    </Suspense>
  );
}
